const guideContent = {
  title: '가이드 관리',
  content: `
  <div class="page-title">[가이드 관리]</div>

# [개요]
매뉴얼 관리 기능은 관리자 시스템의 사용 방법을 문서화하고 관리하기 위한 도구입니다. 이 문서에서는 **매뉴얼의 조회, 작성 규칙 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 매뉴얼 조회 | 좌측 메뉴 트리에서 원하는 매뉴얼 선택 | 관리자 |
| 매뉴얼 이동 | 메뉴 간 자유로운 이동으로 매뉴얼 확인 | 관리자 |

# [조회]
좌측 메뉴 트리에서 원하는 매뉴얼을 선택하여 조회할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 메뉴 트리 | 좌측 네비게이션 | • 매뉴얼 목록 확인<br>• 메뉴 확장/축소<br>• 매뉴얼 선택 |
| 내용 영역 | 매뉴얼 콘텐츠 | • 마크다운 형식의 매뉴얼 표시<br>• 이미지 및 표 포함 |

# [작성 규칙]
매뉴얼은 다음과 같은 규칙에 따라 작성됩니다.

### 📋 구성 요소
| 항목 | 설명 | 예시 |
|------|------|------|
| 제목 | • 대괄호로 구분<br>• 주요 기능명 표시 | # [그룹 관리] |
| 개요 | • 해당 기능 설명<br>• 주요 기능 요약 표 포함 | 그룹 관리는 직원들의 권한을... |
| 상세 설명 | • 조회/등록/수정 등 주요 기능별 설명<br>• 화면 구성 및 기능 표 포함 | # [조회]<br>등록된 그룹의 목록을... |
| 주의사항 | • ⚠️ 아이콘 사용<br>• 중요 제약사항 안내 | > ⚠️ **주의사항**<br>- 필수 항목... |
| 팁 | • 💡 아이콘 사용<br>• 유용한 사용 방법 안내 | > 💡 **Tip**<br>- 드래그 앤 드롭으로... |

> 💡 **Tip**
> - 각 매뉴얼은 동일한 형식을 유지하여 일관성 있게 작성됩니다.
> - 스크린샷은 실제 화면과 동일하게 캡처하여 포함합니다.
> - 표와 이미지를 적절히 활용하여 이해하기 쉽게 작성합니다.

> ⚠️ **주의사항**
> - 매뉴얼 작성 시 정해진 형식을 준수해야 합니다.
> - 스크린샷의 개인정보는 반드시 마스킹 처리해야 합니다.
> - 기능이 변경될 경우 매뉴얼도 즉시 업데이트해야 합니다.
  `,
};

export default guideContent;
